import './app.css';
import Layout from './static-layout/layout';
import Template from './cms-templates/template';
import SignIn from './staff-signin/signin';
import Slider from './cms-templates/slider';
import AssetImg from './lib/asset-img';
import Settings from './staff-settings/settings';
import Admin from './staff-admin/admin';
import Cms from './staff-cms/cms';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route 
                    path="/" 
                    element={<Navigate to="/v1/ui/page/home" replace />}
                />
                <Route 
                    path="/v1/ui/page/:alias" 
                    element={<Template />} // Template interacts with react-router directly 
                />
                <Route 
                    path="/v1/ui/staff/page/signin" 
                    element={<Layout
                        links={[
                            { href: "/v1/ui/page/home", text: "home" },
                        ]}>
                        <SignIn><Slider>{[2,3,4,5,6].map(id => <AssetImg id={id} />)}</Slider></SignIn>
                    </Layout>} 
                />
                <Route 
                    path="/v1/ui/staff/page/settings" 
                    element={<Layout
                        links={[
                            { href: "/v1/ui/page/home", text: "home" },
                            { href: "/v1/ui/staff/page/admin", text: "admin" },
                            { href: "/v1/ui/staff/page/cms", text: "cms" },
                            { href: "#", text: "sign out", fn: async (e) => {
                                e.preventDefault();
                                await fetch('/v1/api/auth/cookie', { method: 'DELETE', credentials: 'include' });
                                window.location.href = '/v1/ui/staff/page/signin';
                            } }
                        ]}>
                        <Settings><Slider>{[7, 8, 9].map(id => <AssetImg id={id} />)}</Slider></Settings>
                    </Layout>} 
                />
                <Route 
                    path="/v1/ui/staff/page/admin" 
                    element={<Layout
                        links={[
                            { href: "/v1/ui/page/home", text: "home" },
                            { href: "/v1/ui/staff/page/settings", text: "settings" },
                            { href: "/v1/ui/staff/page/cms", text: "cms" }
                        ]}>
                        <Admin />
                    </Layout>}
                />
                <Route 
                    path="/v1/ui/staff/page/cms" 
                    element={<Layout
                        links={[
                            { href: "/v1/ui/page/home", text: "home" },
                            { href: "/v1/ui/staff/page/settings", text: "settings" },
                            { href: "/v1/ui/staff/page/admin", text: "admin" }
                        ]}>
                        <Cms />
                    </Layout>} 
                />
                <Route 
                    path="*" 
                    element={<Navigate to="/v1/ui/page/home" replace />}
                />
            </Routes>
        </BrowserRouter>
    )
}
